import { NAME_SPACE } from './config';
import mobileNav from './MobileNav.vue';

export default {
    name: NAME_SPACE,
    components: {
        'mobile-nav': mobileNav,
    },
};
